<template>
  <common-wrap :preview-data="previewData" v-loading="loading">
    <div class="pdf-wrap" id="pdf-wrap"></div>
  </common-wrap>
</template>

<script>
import commonWrap from "@/components/commonWrap";
import common from "@/mixins/common";

export default {
  name: "pdf-preview",
  components: {
    commonWrap
  },
  mixins: [common],
  data() {
    return {
      // loading: false,
      path: ''
    };
  },
  async mounted() {
    const res = await this.getBlobData();
    if (res) {
      const blob = new Blob([res.data], {
        type: 'application/pdf'
      });
      console.log('res', res);
      this.path = window.URL.createObjectURL(blob);
      this.render();
    }
  },
  methods: {
    // async getBlobData() {
    //   this.loading = true;
    //   const res = await this.$http.get(this.previewData.fileUrl, {
    //     responseType: 'blob'
    //   });
    //   this.loading = false;
    //   if (res.data) {
    //     const blob = new Blob([res.data], {
    //       type: 'application/pdf'
    //     });
    //     console.log('res', res);
    //     this.path = window.URL.createObjectURL(blob);
    //     this.render();
    //   } else {
    //     this.$message({
    //       type: 'error',
    //       message: res.data.message || '预览资源加载异常'
    //     });
    //   }
    // },
    render() {
      const PDFObject = require('pdfobject');
      PDFObject.embed(this.path, '#pdf-wrap');
    }
  }
}
</script>

<style lang="scss" scoped>
.pdf-wrap {
  position: relative;
  width: 100vw;
  height: 100vh;
}
</style>
